@value pdsDarkGray, pdsLightGray, pdsWhite, principalBlue, smallScreen from './common.module.css';

/* Tooltip Styles */
.tooltip {
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 1px;
    margin-left: 5px;

    background-color: principalBlue;
    color: pdsWhite;
    text-align: center;

    cursor: pointer;
    transition: all 0.2s ease-out;
}

.tooltip::before, .tooltip::after {
    position: absolute;
    opacity: 0;
    transition: all 0.2s ease-out;
}

.tooltip::before {
    content: "";
    border-width: 10px 12px 0 12px;
    border-style: solid;
    border-color: pdsLightGray transparent;

    /* Position to the right by default */
    left: 15px;
    top: 7px;
    transform: rotate(90deg);
}

.tooltip::after {
    content: attr(data-tooltip);
    width: 200px;
    padding: 15px 25px;
    font-size: 12px;
    color: pdsDarkGray;
    background-color: pdsLightGray;
    border-radius: 4px;
    box-shadow: 2px 2px 4px #00000029;
    pointer-events: none;

    /* Position to the right by default */
    left: 32px;
    top: calc(-75%);
}

/* Allow tooltip to be forced to top on all screens. */
.tooltip[data-tooltip-position='top']::before {
    left: -2px;
    top: -10px;
    transform: rotate(0deg);
}

.tooltip[data-tooltip-position='top']::after {
    top: auto;
    left: -130px;
    bottom: 30px;
}


/* On small screens, put the tooltip above */
@media all and (max-width: smallScreen) {
    .tooltip::before {
        left: -2px;
        top: -10px;
        transform: rotate(0deg);
    }

    .tooltip::after {
        top: auto;
        left: auto;
        bottom: 30px;
        left: -50px;
    }
}

.tooltip:hover::before, .tooltip:hover::after {
  opacity: 1;
}

